import { api } from '../api'

export const taskResponsibleEstimateApi = api
  .enhanceEndpoints({
    addTagTypes: ['TaskResponsibleEstimate', 'Task'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      updateResponsibleEstimate: build.mutation({
        query: ({ estimateId, body }) => ({
          url: `/task-responsible-estimate/${estimateId}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: (_result, _error, { taskId }) => [
          { type: 'Task', id: taskId },
          { type: 'TaskResponsibleEstimate', id: taskId },
        ],
      }),

      deleteResponsibleEstimate: build.mutation({
        query: ({ estimateId }) => ({
          url: `/task-responsible-estimate/${estimateId}`,
          method: 'DELETE',
        }),
        invalidatesTags: (_result, _error, { taskId }) => [
          { type: 'Task', id: taskId },
          { type: 'TaskResponsibleEstimate', id: taskId },
        ],
      }),
    }),
  })

export const {
  useUpdateResponsibleEstimateMutation,
  useDeleteResponsibleEstimateMutation,
} = taskResponsibleEstimateApi
